import Events from "@/events"
import { mergedEvent$ } from '@/services/push'
import { initPush } from "@/services/push";

function commonEventHandler(event, item) {
  return {
    ...item,
    id: item.id,
    event: event
  }
}

const CT = {
  load: {
    update: {
      event: Events.EDIT_LOADS,
      handler: commonEventHandler
    },
    add: {
      event: Events.NEW_LOADS,
      handler: commonEventHandler
    },
    delete: {
      event: Events.DELETE_LOADS,
      handler: commonEventHandler
    }
  },
  driver: {
    update: {
      event: Events.EDIT_DRIVER,
      handler: commonEventHandler
    },
    add: {
      event: Events.NEW_DRIVER,
      handler: commonEventHandler
    },
    delete: {
      event: Events.DELETE_DRIVER,
      handler: commonEventHandler
    },
    position_update: {
      event: Events.EDIT_DRIVER_GPS,
      handler: commonEventHandler
    },
    driverSwitchGps: {
      event: Events.DRIVER_SWITCH_GPS,
      handler: commonEventHandler
    }
  },
  // document: {
  //   update: {
  //     event: Events.EDIT_DOCUMENT,
  //     handler: commonEventHandler
  //   },
  //   add: {
  //     event: Events.NEW_DOCUMENT,
  //     handler: commonEventHandler
  //   },
  //   delete: {
  //     event: Events.DELETE_DOCUMENT,
  //     handler: commonEventHandler
  //   },
  // },
  // expense: {
  //   update: {
  //     event: Events.EDIT_EXPENSE,
  //     handler: commonEventHandler
  //   },
  //   add: {
  //     event: Events.NEW_EXPENSE,
  //     handler: commonEventHandler
  //   },
  //   delete: {
  //     event: Events.DELETE_EXPENSE,
  //     handler: commonEventHandler
  //   },
  // },
}

class NotificationPusher {
  constructor(bus) {
    this.$bus = bus
    this._nPusher = null
    // init authed pusher
    this._init()
  }
  _init() {
    const XAuthToken = this.$bus.$store.state.user.XAuthToken;
    if (!XAuthToken) {
      setTimeout(() => this._init(), 1000)
      return
    }
    if (!this._nPusher) {
      console.debug('NotificationPusher: Created nPusher')
      initPush({
        type: 'init',
        authBy: 'x-auth-token',
        ['x-auth-token']: XAuthToken
      })
      this._nPusher = {
        info: mergedEvent$.subscribe(({params}) => {
          let x = params || {}
          if (x.code === 200 && x.data && x.data.data && x.data.data.info) {
            let info = {}
            let obj = {}
            try {
              info = JSON.parse(x.data.data.info)
              obj[x.data.data.event] = info
            } catch{
              console.log('error')
            }
            this._update({data: JSON.stringify(obj)})
          }
        }),
      }
      // test data
      if (process.env.NODE_ENV !== 'production') {
        // this._test()
      }
    } else {
      this._nPusher.info.unsubscribe()
      // this._nPusher.company.close()
      this._nPusher = null
      console.debug('NotificationPusher: Close nPusher')
    }

  }
  publish(event) {
    // this.$bus.$emit(event, data)
    setTimeout(() => {
      this._update({data: JSON.stringify(event)})
    })
  }
  _test() {
    const data = {system_message: {
      driver: 1600,
      message: "{driver} has departed from pickup for task ({pickup_city} {pickup_state} - {delivery_city} {delivery_state})",
      module: "eld-task-leave",
      taskId: 10813,
      type: "notify",
      param: '123',
      created_time: Date.now(),
    }}
    this.publish(data)
  }

  _update(data) {
    data = JSON.parse(data.data)
    console.log('Push Data:', data)
    if (data['system_message']) {
      console.debug('SendNotification: SystemMessage')
      this.$bus.$emit(Events.DISPATCH_PUSH, data.system_message)
      this.$bus.$store.dispatch('dataCenter/systemMessage', [data.system_message])
      return
    }

    Object.keys(data).forEach(key => {
      if (CT[key]) {
        const eData = CT[key]
        const item = data[key]
        const type = item.type
        if (eData[type]) {
          const event = eData[type].event
          const handler = eData[type].handler
          console.debug('SendNotification: Event', event)
          this.$bus.$emit(event, handler(event, item))
        }
      }
    })
  }
}

let instance = null;
export function notificationPusherInit($bus, interval) {
  console.debug("notificationPusherInit");
  if (!instance) {
    instance = new NotificationPusher($bus, interval);
  }
}

export function getNotificationPusherInstance() {
  return instance;
}
